import React, { forwardRef } from 'react'
import styles from './FileElement.module.sass'
import { FileData, isFileData } from '../../../../responses/files'
import clsx from 'clsx'
import Image from '../Image/Image'
import fileSize from 'filesize'
import Ellipsis from '../../../etc/Ellipsis/Ellipsis'
import { motion } from 'framer-motion'
import CloseIcon from '../../../../../files/close.svg'
import Button from '../../../controls/Button/Button'
import DownloadIcon from 'files/download.svg'
import { urlWithParams } from '../../../../http/utils'
import { ROUTES } from '../../../../http/routes'
import Spinner from '../../../etc/Spinner/Spinner'
import { Classes } from '../../../../styles'

interface Props {
    className?: string,
    file: File | FileData,
    onClick?: (event: React.MouseEvent) => void,
    loading?: boolean,
    minimal?: boolean,
    delete?: boolean,
    active?: boolean,
    layout?: boolean
}

const FileElement = forwardRef<HTMLDivElement, Props>((props, ref) => <motion.div
    ref={ref}
    className={clsx(props.className, styles.element, {
        [styles.active]: props.active,
        [styles.minimal]: props.minimal,
        [styles.interactive]: props.onClick,
    })}
    onClick={props.onClick}
    layout={props.layout}
    initial={{opacity: 0}}
    animate={{opacity: 1}}
    exit={{opacity: 0}}
>
    {
       props.loading? <div className={clsx(styles.icon, Classes.flexCenter)}>
           <Spinner/>
           {
               props.delete && <div className={styles.overlay}>
                   <CloseIcon/>
               </div>
           }
       </div>: <Image className={styles.icon} file={props.file}>
            {
                props.delete && <div className={styles.overlay}>
                    <CloseIcon/>
                </div>
            }
        </Image>
    }
    <Ellipsis className={clsx(styles.name, styles.text)}>{props.file.name}</Ellipsis>
    <span className={clsx(styles.size, styles.text)}>{fileSize(props.file.size)}</span>
    {
        !props.delete && isFileData(props.file) && <a
            className={styles.download}
            href={urlWithParams({filename: props.file.filename})(ROUTES.FILE_ORIGINAL)}
            onClick={event => event.stopPropagation()}
        >
            <Button>
                <DownloadIcon/>
            </Button>
        </a>
    }
</motion.div>)

FileElement.displayName = 'FileElement'

export default FileElement